$(function () {

    /* register JCarousel for Top Interview section */
    var interviewJCarousel = $('#interview-jcarousel'),
        jCarouselList = $('.card-panel-group'),
        jCarouselItem = $('.card-panel'),
        prevButton = $('#interview-jcarousel-prev'),
        nextButton = $('#interview-jcarousel-next'),
        perPage = 3,
        pagination = $('#interview-jcarousel-paginate');
    registerJCarousel(interviewJCarousel, jCarouselList, jCarouselItem, prevButton, nextButton, perPage, pagination);

    /* register JCarousel for Top Column section */
    var columnJCarousel = $('#column-jcarousel'),
        jCarouselList = $('.card-panel-group'),
        jCarouselItem = $('.card-panel'),
        prevButton = $('#column-jcarousel-prev'),
        nextButton = $('#column-jcarousel-next'),
        perPage = 3,
        pagination = $('#column-jcarousel-paginate');
    registerJCarousel(columnJCarousel, jCarouselList, jCarouselItem, prevButton, nextButton, perPage, pagination);

    /* register JCarousel for Related article */
    var articleJCarousel = $('#article-jcarousel'),
        jCarouselList = $('.card-panel-group'),
        jCarouselItem = $('.card-panel'),
        prevButton = $('#article-jcarousel-prev'),
        nextButton = $('#article-jcarousel-next'),
        perPage = 3,
        pagination = $('#article-jcarousel-paginate');
    registerJCarousel(articleJCarousel, jCarouselList, jCarouselItem, prevButton, nextButton, perPage, pagination);

    /* register JCarousel for Hospital Detail - Top */
    var hospitalJCarousel = $('#hospital-top-slider'),
        jCarouselList = hospitalJCarousel.find('.slider-fluid-item-group'),
        jCarouselItem = hospitalJCarousel.find('.slider-fluid-item'),
        prevButton = hospitalJCarousel.find('.slider-fluid-btn-prev'),
        nextButton = hospitalJCarousel.find('.slider-fluid-btn-next'),
        perPage = 1,
        pagination = hospitalJCarousel.find('.slider-fluid-pagination');
    registerJCarousel(hospitalJCarousel, jCarouselList, jCarouselItem, prevButton, nextButton, perPage);
    /* register pagination using plugin */
    pagination
        .on('jcarouselpagination:active', 'a', function () {
            $(this).html('').append('<span class="teech-icon icon-circle-o shadow-sm rounded-circle"></span>');
        })
        .on('jcarouselpagination:inactive', 'a', function () {
            $(this).html('').append('<span class="teech-icon icon-ellipse shadow-sm rounded-circle"></span>');
        })
        .jcarouselPagination({
            item: function (page) {
                return '<a href="#' + page + '" class="text-decoration-none text-white mx-2"><span class="teech-icon icon-ellipse shadow-sm rounded-circle"></span></a>';
            }
        });

});

/**
 *
 * @param {Element} jCarouselRoot
 * @param {Element} jCarouselList
 * @param {Element} jCarouselItem
 * @param {Element} prevButton
 * @param {Element} nextButton
 * @param {Number} perPage
 * @param {Element} pagination
 */
function registerJCarousel(jCarouselRoot, jCarouselList, jCarouselItem, prevButton, nextButton, perPage, pagination) {
    if (!jCarouselRoot || !jCarouselList || !jCarouselItem || !prevButton || !nextButton) {
        console.error('Missing Arguments')
        return;
    }
    if (!perPage) {
        perPage = 1;
    }

    var instantJCarousel = jCarouselRoot
        .on('jcarousel:createend', function (event, carousel) {
            carousel.elementPagination = pagination || null;
            carousel.prevSlideButton = prevButton;
            carousel.nextSlideButton = nextButton;
            carousel.perPage = Math.ceil(perPage);
            carousel.currentPage = Math.ceil($(this).jcarousel('items').length) < 1 ? 0 : 1;
            carousel.totalPage = Math.ceil($(this).jcarousel('items').length / carousel.perPage);
            carousel.totalItem = Math.ceil($(this).jcarousel('items').length);

            /* return pagination index from jcarousel pagination plugin */
            carousel.paginationIndex = (jcarousel) => {
                if (!jcarousel) {
                    jcarousel = jCarouselRoot;
                }
                let fullyVisibleIndex = $.map($(jcarousel).jcarousel('fullyvisible'), function (item) {
                    return item.dataset['index']
                });
                return Math.max.apply(Math, fullyVisibleIndex);
            };

            prevButton.attr('disabled', true);
            if (carousel.totalPage <= 1) {
                nextButton.attr('disabled', true);
            };

            /* render number of jcarousel page to element pagination */
            (carousel.elementPagination) ? carousel.elementPagination.html('').append(carousel.currentPage + ' / ' + carousel.totalPage) : '';
        })
        .on('jcarousel:animateend', async function (event, carousel) {

            await carousel;

            /* if we register pagination using plugin */
            (!carousel.elementPagination) ? carousel.currentPage = carousel.paginationIndex() : '';

            if (carousel.currentPage <= 1) {
                carousel.nextSlideButton.removeAttr('disabled');
                carousel.prevSlideButton.attr('disabled', true);
                carousel.currentPage = 1;
            }
            else if (carousel.currentPage >= carousel.totalPage) {
                carousel.prevSlideButton.removeAttr('disabled');
                carousel.nextSlideButton.attr('disabled', true);
                carousel.currentPage = carousel.totalPage;
            }
            else {
                carousel.nextSlideButton.removeAttr('disabled');
                carousel.prevSlideButton.removeAttr('disabled');
            }

            /* render number of jcarousel page to element pagination of we don't register by using plugin */
            (carousel.elementPagination) ? carousel.elementPagination.html('').append(carousel.currentPage + ' / ' + carousel.totalPage) : null;
        })
        .jcarousel({
            list: jCarouselList,
            items: jCarouselItem,
            animation: 'slow',
            transitions: true
        });

    prevButton.jcarouselControl({
        target: '-=' + perPage,
        animation: true,
        method: function () {
            this.carousel()
                .jcarousel('scroll', this.options('target'), this.options('animation'), function () {
                    (this.currentPage > 1) ? this.currentPage -= 1 : this.currentPage = 1;
                });
        }

    });

    nextButton.jcarouselControl({
        target: '+=' + perPage,
        animation: true,
        method: function () {
            this.carousel()
                .jcarousel('scroll', this.options('target'), this.options('animation'), function () {
                    (this.currentPage < this.totalPage) ? this.currentPage = this.currentPage + 1 : this.currentPage = this.totalPage;
                });
        }
    });

    return instantJCarousel;
}
